import React from 'react';
import { StyleSheet, View, Text } from './components/base_components';
import ProgressSpinner from './components/progress_spinner';
import StandardBoxList from './components/standard_box_list';

import UserStore from './stores/user_store';
import MediaGrantStore from './stores/media_grant_store';

const styles = StyleSheet.create({
  mediaGrantListScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
});

export default function MediaGrantListScreen() {
  const org = UserStore.useOrg();
  const list = MediaGrantStore.useList(org?.org_id);

  React.useEffect(() => {
    MediaGrantStore.fetch(org?.org_id);
  }, [org?.org_id]);

  let content: any = null;
  if (!list) {
    content = <ProgressSpinner />;
  } else if (list.length === 0) {
    content = (
      <View style={styles.dialog}>
        <Text style={styles.text}>
          Looks like you don't have access to any files.
        </Text>
        <Text style={styles.text}>
          Contract your organizations administrator to get access.
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.mediaGrantListScreen}>
      <StandardBoxList
        title='Containers'
        detail={list?.length}
        headers={['Name']}
        rows={list?.map?.((grant: any) => ({
          url: `/home/${grant.grant_name}/`,
          list: [grant?.grant_name],
        }))}
      >
        {content}
      </StandardBoxList>
    </View>
  );
}
